import { render, staticRenderFns } from "./ReadOnlyItems.vue?vue&type=template&id=445e5612"
import script from "./ReadOnlyItems.vue?vue&type=script&lang=js"
export * from "./ReadOnlyItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports